/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { Screen, Text } from "components"
import React, { useCallback, useState } from "react"
import {
  Animated,
  FlatList,
  Platform,
  ScrollView,
  TouchableOpacity,
  View,
  Image,
  StatusBar,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { useSharedValue } from "react-native-reanimated"
import LinearGradient from "react-native-linear-gradient"
import { translate } from "i18n"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { colors } from "colors"
import useResponsiveWidth from "components/fitSize"
import goldCrown from "../../../../assets/images/crown-gold.png"
import silverCrown from "../../../../assets/images/crown-silver.png"
import bronzeCrown from "../../../../assets/images/crown-bronze.png"
import flash from "config/flash"
import EmptyState from "components/EmptyState"
import { useColor } from "app/theme/getThemes"
import RenderHTML from "react-native-render-html"
import StampItems from "components/StampItems"
import { size } from "lodash"
import moment from "moment"

export const VoucherHomeScreen = () => {
  const { companyTheme } = useColor()
  const { userStore, couponStore } = useStores()
  const navigation = useNavigation<any>()
  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const { sessionExpired } = useSessionExpired()

  const [maxHeight] = useState(100)
  const [minHeight] = useState(Platform.OS === "web" ? 60 : 55)
  const [scrollY] = useState(new Animated.Value(0))

  const [filter, setFilter] = useState([
    { name: "TOWEL" },
    { name: "CANDLE" },
    { name: "MAT" },
    { name: "MATTRESS" },
  ])
  const [filterData, setFilterData] = useState([])
  const [point, setPoint] = useState()
  const [reward, setRewards] = useState([])
  const [redemption, setRedemption] = useState([])
  const [stamps, setStamps] = useState<any>([])
  const [tier, setTier] = useState("")
  const progressValue = useSharedValue(0)
  const [currentStampIndex, setCurrentStampIndex] = useState(0)
  const handleCarouselChange = (index) => {
    setCurrentStampIndex(index)
  }

  const toggleSelection = (selectedItem) => {
    setFilterData((prevSelected) => {
      // Check if the item is already selected
      if (prevSelected.some((item) => item.name === selectedItem.name)) {
        // Remove the item from selected items
        return prevSelected.filter((item) => item.name !== selectedItem.name)
      } else {
        // Add the item to selected items
        return [...prevSelected, selectedItem]
      }
    })
  }

  useFocusEffect(
    useCallback(() => {
      getUserPoint()
      getCoupon()
      getTierByUserId()
      getStamp()
    }, []),
  )

  const getCoupon = async () => {
    try {
      const res = await fetch(`${process.env.API_URL}/api/voucher/coupon/${userStore?.id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })

      if (res.ok) {
        const response = await res.json()
        setRewards(response)
        const coupons = Array.isArray(response) ? response : [response]
        const voucherBetweenSeven = [...coupons].find((coupon) => {
          const startDate = moment(coupon.start_date)
          const endDate = startDate.clone().add(7, "days")
          return moment().isBetween(startDate, endDate, "day", "[]")
        })

        if (voucherBetweenSeven) {
          const areIdsDifferent =
            voucherBetweenSeven.voucher_catalog_id !== couponStore.newCouponNotifiedId

          if (areIdsDifferent) {
            couponStore.setShowBadge(true)
            couponStore.setNewCouponNotifiedId(firstVoucherForToday.voucher_catalog_id)
          }
        }
      } else {
        const errorMsg = await res.json()
        console.log(errorMsg)
      }
    } catch (e) {
      flash("error", translate("errors.failedToUseVoucher"))
      console.error("Error", e)
    }
  }

  const getTierByUserId = async () => {
    await fetch(`${process.env.API_URL}/api/tier/member/${userStore.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          console.log("Tier ===>", responseData)
          setTier(responseData?.get_member_tier_info?.[0]?.tier_name)
          getVoucher(responseData?.current_tier)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getVoucher = async (filterId) => {
    const typesArray = ["redemption"]
    await fetch(`${process.env.API_URL}/api/voucher?types=${typesArray}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          console.log("voucher ===>", responseData)

          console.log(
            responseData.filter(
              (a) =>
                a.status === "active" && (a.member_tier_id === filterId || a.member_tier_id === 0),
            ),
          )

          setRedemption(
            responseData.filter(
              (a) =>
                a.status === "active" &&
                a.voucher_type === "redemption" &&
                (a.member_tier_id === filterId || a.member_tier_id === 0),
            ),
          )
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  const getStamp = async () => {
    await fetch(`${process.env.API_URL}/api/stamps/member/${userStore.id}/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          setStamps(responseData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreivePromotion"))
          }
        }
      })
      .catch((e) => {
        flash("error", translate("errors.failedToRetreivePromotion"))
        console.error(e)
      })
  }

  console.log(stamps)

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data?.toLocaleString())
          userStore?.update({
            totalPoint: responseData?.data,
            // totalPoint: 9000,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const headerHeight = scrollY.interpolate({
    inputRange: [0, maxHeight - minHeight],
    outputRange: [maxHeight, minHeight],
    extrapolate: "clamp",
  })

  const bottomContentOpacity = scrollY.interpolate({
    inputRange: [0, (maxHeight - minHeight) / 2, maxHeight - minHeight],
    outputRange: [1, 1, 0],
    extrapolate: "clamp",
  })

  const topContentOpacity = scrollY.interpolate({
    inputRange: [0, (maxHeight - minHeight) / 2, maxHeight - minHeight],
    outputRange: [0, 0, 1],
    extrapolate: "clamp",
  })

  const [isMinimized, setIsMinimized] = useState(false)

  const handleScroll = Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }], {
    useNativeDriver: false,
    listener: (event) => {
      const scrollOffset = event.nativeEvent.contentOffset.y
      setIsMinimized(scrollOffset > (maxHeight - minHeight) / 2)
    },
  })

  function limitWords(text: string, wordLimit: number): string {
    const words = text.split(/\s+/) // Split the text by spaces
    if (words.length <= wordLimit) {
      return text
    }
    return words.slice(0, wordLimit).join(" ") + "..." // Limit the words and add ellipsis
  }

  return (
    <Screen>
      <View style={style.container}>
        <ScrollView
          scrollEventThrottle={16}
          showsVerticalScrollIndicator={false}
          style={style.flex}
          onScroll={handleScroll}
        >
          <View style={[{ marginTop: maxHeight }, style.flex]}>
            {/* <View style={style.mt15}>
              <FlatList
                style={{ paddingLeft: "3%" }}
                data={filter}
                horizontal
                showsHorizontalScrollIndicator={false}
                renderItem={({ item }) => {
                  const isSelected = filterData.some((selected) => selected.name === item.name)

                  return (
                    <TouchableOpacity
                      onPress={() => toggleSelection(item)}
                      style={
                        isSelected
                          ? [
                              style.activeFilter,
                              {
                                borderColor: companyTheme.first,
                                backgroundColor: companyTheme.first,
                              },
                            ]
                          : [style.unactiveFilter, { borderColor: companyTheme.first }]
                      }
                    >
                      <Text
                        style={
                          isSelected
                            ? [style.activeFilterText, {}]
                            : [style.unactiveFilterText, { color: companyTheme.first }]
                        }
                      >
                        {item?.name}
                      </Text>
                    </TouchableOpacity>
                  )
                }}
              />
            </View> */}
          </View>
          <View style={style.mt15}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: "3%",
                paddingTop: "5%",
              }}
            >
              <Text>For You</Text>
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate("foryou")
                }}
              >
                <Text style={[style.showAllText, { color: companyTheme.first }]}>
                  {translate("common.showAll")}
                </Text>
              </TouchableOpacity>
            </View>
            <FlatList
              style={[style.mt10, { padding: 10, width: "100%" }]}
              data={reward}
              horizontal
              contentContainerStyle={{ padding: 5 }}
              showsHorizontalScrollIndicator={false}
              renderItem={({ item }) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      navigation.navigate("forYouDetails", {
                        item,
                      })
                    }}
                    style={style.contentContainerV}
                  >
                    <Image
                      source={{
                        uri: item?.voucher_image,
                      }}
                      resizeMode="cover"
                      style={{
                        width: 180,
                        maxWidth: 180,
                        height: 200,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                        borderColor: colors.border,
                      }}
                    />

                    {/* <View style={{ marginTop: 5 }}>
                      <Text numberOfLines={2}>{item?.voucher_name}</Text>
                    </View> */}
                    {/* <View style={{ marginTop: 5 }}> */}
                    {/* <RenderHTML
                        source={{ html: limitWords(item?.voucher_description || "", 3) }}
                      /> */}
                    {/* <Text numberOfLines={2} style={style.desc_text}>
                        {item?.voucher_description}
                      </Text> */}
                    {/* </View> */}

                    <View style={{ marginTop: 5 }}>
                      <Text style={style.voucherText} numberOfLines={2}>
                        {item?.voucher_name}
                      </Text>
                    </View>
                    <View style={{ marginTop: 5 }}>
                      <RenderHTML
                        source={{ html: limitWords(item?.voucher_description || "", 3) }}
                        tagsStyles={{ p: { ...style.pointText, color: companyTheme.first } }}
                      />
                    </View>
                  </TouchableOpacity>
                )
              }}
              ListEmptyComponent={() => {
                return (
                  <View style={{ width: (width * 90) / 100 }}>
                    <EmptyState />
                  </View>
                )
              }}
            />
          </View>
          <View style={style.mt15}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: "3%",
              }}
            >
              <Text>Redemption</Text>
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate("redeem")
                }}
              >
                <Text style={[style.showAllText, { color: companyTheme.first }]}>
                  {translate("common.showAll")}
                </Text>
              </TouchableOpacity>
            </View>
            <FlatList
              style={[style.mt10, { paddingLeft: 10 }]}
              data={redemption}
              horizontal
              contentContainerStyle={{ padding: 5 }}
              showsHorizontalScrollIndicator={false}
              renderItem={({ item }) => {
                return (
                  <TouchableOpacity
                    onPress={() =>
                      navigation?.navigate("voucherDetail", { item, routeFrom: "redeemVoucher" })
                    }
                    style={style.contentContainerV}
                  >
                    <Image
                      source={{
                        uri: item?.voucher_image,
                      }}
                      resizeMode="cover"
                      style={{
                        width: 180,
                        maxWidth: 180,
                        height: 200,
                        borderTopLeftRadius: 10,
                        borderTopRightRadius: 10,
                        borderColor: colors.border,
                      }}
                    />
                    <Text style={style.voucherText}>{item?.voucher_name}</Text>
                    <Text
                      style={[style.pointText, { color: companyTheme.first, marginBottom: 10 }]}
                    >
                      {item?.voucher_point_required?.toLocaleString() || 0}{" "}
                      {translate("redeemScreen.pts")}
                    </Text>
                  </TouchableOpacity>
                )
              }}
              ListEmptyComponent={() => {
                return (
                  <View style={{ width: (width * 90) / 100 }}>
                    <EmptyState />
                  </View>
                )
              }}
            />
          </View>

          {size(stamps) > 0 ? (
            <View style={[style.mt15, { paddingBottom: 20 }]}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingHorizontal: 10,
                }}
              >
                <Text>My Stamps</Text>
                <TouchableOpacity
                  onPress={() => {
                    navigation.navigate("stamps")
                  }}
                >
                  <Text style={[style.showAllText, { color: companyTheme.first }]}>
                    {translate("common.showAll")}
                  </Text>
                </TouchableOpacity>
              </View>

              <FlatList
                data={stamps}
                renderItem={({ item }) => {
                  return (
                    <View
                      style={{
                        width: "100%",
                        alignItems: "center",
                        marginTop: 15,
                      }}
                    >
                      <StampItems stamps={item} widths={"95%"} />
                    </View>
                  )
                }}
                ListEmptyComponent={() => {
                  return (
                    <View style={{ width: (width * 90) / 100 }}>
                      <EmptyState />
                    </View>
                  )
                }}
              />
            </View>
          ) : null}
        </ScrollView>
      </View>

      <LinearGradient
        style={[style.linearGradient, { width }]}
        colors={[companyTheme.first, companyTheme.second]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
      >
        <Animated.View
          style={[
            style.animatedViewContainer,
            { height: headerHeight, marginTop: StatusBar.currentHeight },
          ]}
        >
          <View style={style.headerContainer}>
            {isMinimized ? (
              <View style={style.headerContentContainer}>
                <Animated.View
                  style={{
                    opacity: topContentOpacity,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Text style={[style.headerBottomPointText, { color: "white" }]}>
                    {tier?.toUpperCase()}
                  </Text>
                  <Image
                    source={
                      tier?.toLowerCase() === "gold"
                        ? goldCrown
                        : tier?.toLowerCase() === "silver"
                        ? silverCrown
                        : bronzeCrown
                    }
                    style={[style.headerBottomButtonImage, { marginLeft: 10, borderRadius: 50 }]}
                  />
                </Animated.View>
                <Animated.Text style={[{ opacity: topContentOpacity }, style.headerTopPointText]}>
                  {point} {translate("common.shortFormPoint")}
                </Animated.Text>
              </View>
            ) : (
              <Animated.View
                style={[{ opacity: bottomContentOpacity }, style.headerBottomBigContainer]}
              >
                <View style={style.headerBottomPointContainer}>
                  <View style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <Text style={[style.headerBottomPointText, { color: "white" }]}>
                      {tier.toUpperCase()}
                    </Text>
                    <Image
                      source={
                        tier.toLowerCase() === "gold"
                          ? goldCrown
                          : tier.toLowerCase() === "silver"
                          ? silverCrown
                          : bronzeCrown
                      }
                      style={[style.headerBottomButtonImage, { marginLeft: 10, borderRadius: 50 }]}
                    />
                  </View>
                  <TouchableOpacity
                    style={[style.headerBottomButton, { borderColor: companyTheme.first }]}
                    onPress={() => navigation.navigate("voucher")}
                  >
                    <Image
                      source={require("../../../../assets/giftIcon.gif")}
                      style={style.headerBottomButtonImage}
                    />
                    <Text style={{ color: companyTheme.first }}>My Rewards</Text>
                  </TouchableOpacity>
                </View>
                <TouchableOpacity
                  style={style.pointContainer}
                  onPress={() => navigation.navigate("pointHistory")}
                >
                  <Text style={style.text}>{translate("redeemScreen.availablePoint")} : </Text>
                  <Text style={style.text}>
                    {point || 0} {translate("common.shortFormPoint")}
                  </Text>
                </TouchableOpacity>
              </Animated.View>
            )}
          </View>
        </Animated.View>
      </LinearGradient>
    </Screen>
  )
}
